import React from 'react';
import { gql, useQuery } from "@apollo/client";
import jsPDF from 'jspdf';

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      estado
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function Pedidos() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
  if (loading) return <img className='app-logo' src="https://thumbs.dreamstime.com/z/marco-del-fondo-de-las-frutas-coloridas-clasificadas-arreglaron-en-un-c%C3%ADrculo-el-blanco-espacio-la-copia-para-texto-adentro-139706746.jpg?ct=jpeg" alt="" />;
  if (error) return <p>Error</p>;

  const pedidos = data.getPedidos;

  const generatePDF = (pedido) => {
    const doc = new jsPDF();
    doc.text(`Número de Pedido: ${pedido.numeroPedido}`, 10, 10);
    doc.text(`Estado: ${pedido.estado}`, 10, 20);
    doc.text(`Nombre del Cliente: ${pedido.nombreCliente}`, 10, 30);
    doc.text(`Dirección del Cliente: ${pedido.direccionCliente}`, 10, 40);
    doc.text(`WhatsApp del Cliente: ${pedido.whatsappCliente}`, 10, 50);
    doc.text(`Nota del Pedido: ${pedido.notaPedido}`, 10, 60);
    doc.text(`Productos:`, 10, 70);
    const productos = JSON.parse(pedido.productos);
    productos.forEach((producto, index) => {
      doc.text(`- ${producto.nombre}: ${producto.precio}`, 10, 80 + (index * 10));
    });
    return doc;
  };

  const downloadAndOpenPDF = (pedido) => {
    const doc = generatePDF(pedido);
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Crear un enlace temporal y abrirlo en una nueva pestaña
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = `pedido_${pedido.numeroPedido}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Abrir el PDF en una nueva pestaña
    window.open(pdfUrl, '_blank');
  };

  const sendPDF = (pedido) => {
    const whatsappUrl = `https://web
.whatsapp.com/send?phone=57${pedido.whatsappCliente}&text=Hola ${pedido.nombreCliente}, aquí está tu pedido. Por favor, adjunta el PDF descargado.`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div>
      {pedidos && pedidos.map((pedido) => (
        <div key={pedido._id}>
          <h1>Número de Pedido: {pedido.numeroPedido}</h1>
          <h2>Estado: {pedido.estado}</h2>
          <p>Nombre del Cliente: {pedido.nombreCliente}</p>
          <p>Dirección del Cliente: {pedido.direccionCliente}</p>
          <p>WhatsApp del Cliente: {pedido.whatsappCliente}</p>
          <p>Nota del Pedido: {pedido.notaPedido}</p>
          <h3>Productos:</h3>
          <ul>
            {pedido.productos && JSON.parse(pedido.productos).map((producto) => (
              <li key={producto.id}>{producto.nombre} <h1>{producto.precio}</h1></li>
            ))}
          </ul>
          <button onClick={() => downloadAndOpenPDF(pedido)}>Descargar y Abrir PDF</button>
          <button onClick={() => sendPDF(pedido)}>Enviar PDF por WhatsApp</button>
        </div>
      ))}
    </div>
  );
}

export default Pedidos;
